<template>
  <div>
    <a-table :scroll="{ x: 1200 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handleTableChange">
      <template slot="taskId" slot-scope="text, record">
        <a-dropdown :trigger="['contextmenu']">
          <div>
            <span v-tc="{ name: '复制任务ID' }" style="cursor: pointer" @click="onTextCopy(`TS-${record.id}`)">{{ `TS-${record.id}` }}</span>
          </div>
          <a-menu slot="overlay">
            <a-menu-item key="1" v-tc="{ name: '复制任务ID' }" @click="onTextCopy(`TS-${record.id}`)"> 复制任务ID </a-menu-item>
            <a-menu-item key="2" v-tc="{ name: '复制Commit信息' }" @click="onTextCopy(`#TS-${record.id}@${record.name}`)"> 复制Commit信息 </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <span slot="status" slot-scope="text, record">
        <task-status-edit :task-id="record.id" :next-status="record.next_status" :status="record.status" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="priority" slot-scope="text, record">
        <task-priority-edit :value="record.priority" :task-id="record.id" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="point" slot-scope="text, record">
        <task-point-edit :value="record.point" :task-id="record.id" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="category" slot-scope="text, record">
        <span v-if="record.extra && record.extra.category && taskCategorys[record.extra.category]">
          <a-tag :color="taskCategorys[record.extra.category].color"> {{ taskCategorys[record.extra.category].name }} </a-tag>
        </span>
        <span v-else>--</span>
      </span>
      <span slot="handlers" slot-scope="text, record">
        <task-user-edit :value="record.handlers" :source-id="record.id" @change="onChange" />
      </span>
      <span slot="taskName" slot-scope="text, record">
        <task-name-edit :name="record.name" :task-id="record.id" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="preStartTime" slot-scope="text, record">
        <task-date-edit :data-source="record" item-name="pre_start_time" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="preEndTime" slot-scope="text, record">
        <task-date-edit :data-source="record" item-name="pre_end_time" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="creator" slot-scope="text, record">{{ record.creator.nickname }} </span>
      <span slot="handlers" slot-scope="text, record">
        <task-user-edit :value="record.handlers" :source-id="record.id" :project_id="record.project.id" @change="onChange" />
      </span>
      <span slot="action" slot-scope="text, record">
        <a-dropdown placement="bottomCenter">
          <a-icon type="more" />
          <a-menu slot="overlay">
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onDelete(record)"><a-icon type="delete" /> 删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
    <task-delete-confirm ref="taskDeleteRef" @ok="onChange" />
    <fault-task-edit ref="faultTaskEditRef" @ok="onChange" />
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { onCopy as onTextCopy } from '@/utils/utils';

import FaultTaskEdit from '@/pages/event/components/FaultTaskEdit';
import TaskDateEdit from '@/pages/project/task/components/TaskDateEdit';
import TaskNameEdit from '@/pages/project/task/components/TaskNameEdit';
import TaskUserEdit from '@/pages/project/task/components/TaskUserEdit';
import TaskPointEdit from '@/pages/project/task/components/TaskPointEdit';
import TaskStatusEdit from '@/pages/project/task/components/TaskStatusEdit';
import TaskPriorityEdit from '@/pages/project/task/components/TaskPriorityEdit';
import TaskDeleteConfirm from '@/pages/project/task/components/TaskDeleteConfirm';

const columns = [
  {
    key: 'action',
    align: 'center',
    width: 20,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 110,
    scopedSlots: { customRender: 'taskId' }
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name',
    width: 480,
    scopedSlots: { customRender: 'taskName' }
  },
  {
    title: '处理人',
    dataIndex: 'handlers',
    key: 'handlers',
    width: 160,
    ellipsis: true,
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    width: 80,
    scopedSlots: { customRender: 'priority' }
  },
  {
    width: 100,
    key: 'point',
    title: '任务点',
    dataIndex: 'point',
    scopedSlots: { customRender: 'point' }
  },
  {
    width: 100,
    key: 'category',
    title: '任务分类',
    dataIndex: 'category',
    scopedSlots: { customRender: 'category' }
  },
  {
    width: 120,
    align: 'center',
    title: '计划开始时间',
    dataIndex: 'pre_start_time',
    key: 'pre_start_time',
    scopedSlots: { customRender: 'preStartTime' }
  },
  {
    width: 120,
    align: 'center',
    title: '计划结束时间',
    key: 'pre_end_time',
    dataIndex: 'pre_end_time',
    scopedSlots: { customRender: 'preEndTime' }
  },
  {
    width: 164,
    align: 'center',
    title: '完成时间',
    key: 'completed_time',
    dataIndex: 'completed_time',
    customRender: text => {
      return text || '--';
    }
  },
  {
    width: 100,
    title: '创建人',
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    width: 164,
    align: 'center',
    title: '创建时间',
    key: 'created_time',
    dataIndex: 'created_time'
  }
];

export default {
  components: { TaskStatusEdit, TaskDateEdit, TaskPointEdit, TaskNameEdit, TaskUserEdit, TaskPriorityEdit, FaultTaskEdit, TaskDeleteConfirm },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: [Object, Boolean],
      required: true
    }
  },
  data() {
    return {
      columns,
      taskCategoryItems: [],
      projectId: 0,
      taskData: {},
      sourceId: null,
      editVisible: false
    };
  },
  computed: {
    taskCategorys() {
      return this.taskCategoryItems.reduce((acc, element) => {
        acc[element.id] = element;
        return acc;
      }, {});
    }
  },
  created() {
    this.getTagList();
  },
  methods: {
    onTextCopy,
    /**
     * 添加任务
     * @param {*} faultId 故障ID
     */
    onAdd(faultId) {
      this.$nextTick(() => {
        this.$refs.faultTaskEditRef.onOpen({ fault_id: faultId });
      });
    },

    /**
     * 编辑任务
     * @param {*} record 任务
     */
    onEdit(record) {
      this.$nextTick(() => {
        this.$refs.faultTaskEditRef.onOpen({ ...record, fault_id: record.fault_id });
      });
    },

    /**
     * 删除任务
     * @param {*} record 任务
     */
    onDelete(record) {
      this.$nextTick(() => {
        this.$refs.taskDeleteRef.onOpen(record.id, record.project.id);
      });
    },

    /**
     * 获取任务分类标签列表
     */
    async getTagList() {
      const res = await tagList({ group_code: 'task_category_tag' });
      this.taskCategoryItems = res.data.items;
    },

    /**
     * 任务状态变更
     */
    onChange() {
      this.$emit('change');
    },

    /**
     * 分页变更
     * @param {*} pagination 分页
     */
    handleTableChange(pagination) {
      this.$emit('page-change', pagination);
    }
  }
};
</script>

<style lang="less" scoped>
.add-task-bt {
  margin-bottom: 8px;
}
</style>
